import React from 'react';
import { Accordion, AccordionSummary, Typography, Icon } from '@mui/material';
import { VIDEO, DOCUMENT, MEET, FACE_TO_FACE, AUDIO, MANUAL_EVALUATION, AUTOMATIC_EVALUATION } from 'Constants/General';
import { Apps, ContentPaste, PendingActions } from '@mui/icons-material';
import { Draggable } from 'react-beautiful-dnd';
import faceToFace from 'Images/faceToFace.svg';
import document from 'Images/document.svg';
import audio from 'Images/audio.svg';
import video from 'Images/video.svg';
import meet from 'Images/meet.svg';
import { iconStyle, typographyStyle, acordionStyle, iconTypeStyle, IconContainer } from './style';

const cards = {
  [VIDEO]: video,
  [AUDIO]: audio,
  [DOCUMENT]: document,
  [MEET]: meet,
  [FACE_TO_FACE]: faceToFace,
  [MANUAL_EVALUATION]: <ContentPaste color="primary" />,
  [AUTOMATIC_EVALUATION]: <PendingActions color="primary" />,
};

export default function Module({
  lesson,
  index,
  positionModule,
  setCurrentPositionModule,
  setCurrentPositionLesson,
  setTypeContent,
}) {
  const draggableId = lesson?.id || index;

  const onclick = () => {
    setCurrentPositionModule(positionModule);
    setCurrentPositionLesson(index);
    setTypeContent(lesson.LessonType.name);
  };

  return (
    <Draggable key={draggableId} draggableId={`${draggableId}`} index={index}>
      {provided => (
        <div ref={provided.innerRef} {...provided.draggableProps}>
          <Accordion style={acordionStyle} expanded={false} onClick={onclick}>
            <AccordionSummary>
              <div {...provided.dragHandleProps} style={{ width: '10%' }}>
                <Apps style={iconStyle} />
              </div>
              <Typography style={typographyStyle}>{lesson?.name}</Typography>
              <IconContainer>
                <Icon style={iconTypeStyle}>
                  {typeof cards[lesson.LessonType.name] === 'string' ? (
                    <img src={cards[lesson.LessonType.name]} />
                  ) : (
                    cards[lesson.LessonType.name]
                  )}
                </Icon>
              </IconContainer>
            </AccordionSummary>
          </Accordion>
        </div>
      )}
    </Draggable>
  );
}
